import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import { mg } from '../mg/mg';
import { getOmnistore } from '../stores/Omnistore';

const EMPTY_BOUNDS = {
	top: 0,
	bottom: 0,
	left: 0,
	right: 0,
	height: 0,
	width: 0,
};

export type IOcMeasureBounds = typeof EMPTY_BOUNDS

export const newEmptyBounds = () => ({...EMPTY_BOUNDS});

interface IOcMeasureProps {
	onResize: (bounds: IOcMeasureBounds) => void
	// children: (props: {measureRef: React.Ref<any>}) => React.ElementType //TODO
	children: (props: {measureRef: React.Ref<any>}) => React.ReactNode
}

@observer export class OcMeasure extends React.Component<IOcMeasureProps> {
	@computed get reoctoStore() {
		return getOmnistore().reoctoStore;
	}

	@observable _ref: any = undefined //TODO

	@observable _bounds: IOcMeasureBounds = newEmptyBounds()

	@observable _ticking = false

	_interval: number = 0

	_measure = () : IOcMeasureBounds => {
		if (!this._ref) return this._bounds;
		// Clone because of strange behavior and mutability.
		const bounds: IOcMeasureBounds = this._ref.getBoundingClientRect();
		const result = newEmptyBounds();
		// @ts-ignore
		for (let k of Object.keys(this._bounds)) result[k] = bounds[k];
		return result;
	}

	@action _doMeasure = () => {
		if (this.reoctoStore.isIdle) return;
		const newBounds = this._measure();
		if (mg.shallowEqual(newBounds, this._bounds)) return;
		//console.log('_doMeasure', this._bounds.top, newBounds.top)
		this._bounds = newBounds;
		if (this.props.onResize) this.props.onResize(this._bounds);
	}

	_resizeObserver = new ResizeObserver(this._doMeasure)

	@action _onScrollTick = () => {
		//console.log('_onScrollTicking', window.scrollY)
		this._ticking = false;
		this._doMeasure();
	}

	@action _onScroll = () => {
		if (!this._ticking) window.requestAnimationFrame(this._onScrollTick);
		this._ticking = true;
	}

	componentDidMount() {
		window.addEventListener('scroll', this._onScroll);
		if (this._ref) this._resizeObserver.observe(this._ref);
		this._interval = window.setInterval(this._doMeasure, 200);
		window.setTimeout(this._doMeasure, 10);
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this._onScroll);
		this._resizeObserver.disconnect();
		window.clearInterval(this._interval);
	}

	_handleRef = (n: any) => {
		if (this._ref) this._resizeObserver.disconnect();
		this._ref = n;
		if (this._ref) this._resizeObserver.observe(this._ref);
	}

	render() {
		const {children, ...rest} = this.props;
		return children({measureRef: this._handleRef, ...rest});
	}
}
